import { Controller } from "@hotwired/stimulus";

export default class ClonedDestinationsListController extends Controller {
    static targets = [];
    static values = {
        clonedDestinationsCount: Number,
        toggleParentElementVisibility: Boolean,
    };

    readonly clonedDestinationsCountValue!: number;
    readonly toggleParentElementVisibilityValue!: boolean;

    connect() {
        if (this.toggleParentElementVisibilityValue && this.element.parentElement) {
            this.element.parentElement.hidden = this.clonedDestinationsCountValue === 0;
        }
    }
}
